import ApiRoot from '@http/ApiRoot';

export default async function (id, limit) {
  try {
    const response = await ApiRoot.get(`/banner/${id}`, {
      params: {
        limit
      }
    })
    return response;
  } catch (error) {
    console.error(`getBannerById(${id})`, error)
    return new Error(error)
  }
}
